var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// src/createLineHeightPlugin.ts
import {
  createPluginFactory,
  ELEMENT_DEFAULT,
  getPluginType,
  mapInjectPropsToPlugin
} from "@udecode/plate-common";
var KEY_LINE_HEIGHT = "lineHeight";
var createLineHeightPlugin = createPluginFactory({
  key: KEY_LINE_HEIGHT,
  inject: {
    props: {
      nodeKey: KEY_LINE_HEIGHT,
      defaultNodeValue: 1.5
    }
  },
  then: (editor) => ({
    inject: {
      props: {
        validTypes: [getPluginType(editor, ELEMENT_DEFAULT)]
      }
    },
    then: (_, plugin) => mapInjectPropsToPlugin(editor, plugin, {
      deserializeHtml: {
        getNode: (el, node) => {
          if (el.style.lineHeight) {
            node[plugin.key] = el.style.lineHeight;
          }
        }
      }
    })
  })
});

// src/hooks/useLineHeightDropdownMenu.ts
import {
  focusEditor,
  getBlockAbove,
  getPluginInjectProps,
  isCollapsed,
  useEditorRef,
  useEditorState
} from "@udecode/plate-common";
var useLineHeightDropdownMenuState = () => {
  var _a;
  const editor = useEditorState();
  const { validNodeValues: values = [], defaultNodeValue } = getPluginInjectProps(editor, KEY_LINE_HEIGHT);
  let value;
  if (isCollapsed(editor == null ? void 0 : editor.selection)) {
    const entry = getBlockAbove(editor);
    if (entry) {
      value = (_a = values.find((item) => item === entry[0][KEY_LINE_HEIGHT])) != null ? _a : defaultNodeValue;
    }
  }
  return {
    value,
    values
  };
};
var useLineHeightDropdownMenu = ({
  value
}) => {
  const editor = useEditorRef();
  return {
    radioGroupProps: {
      value,
      onValueChange: (newValue) => {
        setLineHeight(editor, {
          value: Number(newValue)
        });
        focusEditor(editor);
      }
    }
  };
};

// src/transforms/setLineHeight.ts
import {
  getPluginInjectProps as getPluginInjectProps2,
  isBlock,
  setElements,
  unsetNodes
} from "@udecode/plate-common";
var setLineHeight = (editor, {
  value,
  setNodesOptions
}) => {
  const { validTypes, defaultNodeValue, nodeKey } = getPluginInjectProps2(
    editor,
    KEY_LINE_HEIGHT
  );
  const match = (n) => isBlock(editor, n) && !!validTypes && validTypes.includes(n.type);
  if (value === defaultNodeValue) {
    unsetNodes(editor, nodeKey, __spreadValues({
      match
    }, setNodesOptions));
  } else {
    setElements(
      editor,
      { [nodeKey]: value },
      __spreadValues({
        match
      }, setNodesOptions)
    );
  }
};
export {
  KEY_LINE_HEIGHT,
  createLineHeightPlugin,
  setLineHeight,
  useLineHeightDropdownMenu,
  useLineHeightDropdownMenuState
};
//# sourceMappingURL=index.mjs.map